// ECRIT A LA MAIN, icone du fondateur (voir `./index.ts`).
import { createCustomIcon } from './create-custom-icon.js';

/**
 * Partager : la feuille a coin plie, ouverte a gauche sur le noeud de partage
 * (trois points relies). Source `share-file.svg`.
 */
export const IconShareFile = createCustomIcon(
  'IconShareFile',
  '0 0 239.01 239.02',
  <>
    <path
      fill="currentColor"
      d="M182.24,0l56.76,57.04v181.98s-106.99-.03-106.99-.03c4.81-8.17,7.16-15.89,7.44-24.89h74.68s-.05-146.76-.05-146.76l-42.63-42.46h-106.72s0,86.48,0,86.48c-6.58,5.91-10.86,12.41-13.17,21.03-3.58,2.03-6.53,3.54-11.66,5.31l-.06-137.71h142.41Z"
    />
    <path
      fill="currentColor"
      d="M0,184.23v-10.95c4.42-8.05,7.14-14.63,17.9-17.86,8.69-2.61,15.77-.09,23.05,4.51l28.81-14.31c-.31-12.63,7.82-22.45,18.52-25.22,11.66-3.01,23.33,2.68,28.38,12.6,5.53,10.86,2.43,23.47-6.4,30.65-9.3,7.57-22.16,7.4-31.77-.22-10.19,5.11-19.37,9.31-30.21,15.74,11.02,6.33,20.06,10.6,30.43,15.75,9.89-7.71,22.79-7.46,32.05.36,8.65,7.31,11.45,20.1,5.49,30.93-5.26,9.57-17.21,15.37-28.85,11.69-10.19-3.23-18.04-12.62-17.61-24.96l-28.97-14.49c-7.79,5.87-16.56,7.32-25.93,3.55-6.97-2.81-12.1-9.66-14.9-17.76Z"
    />
  </>,
);
